import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PortalApp from './App.portal';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PortalApp />
  </React.StrictMode>
);
